import React from "react";

import Data from './Data';
import Location from './Location';
import Menu from './Menu';
import Other from './Other';
import People from './People';
import Plus from './Plus';
import Minus from './Minus';
import Moon from './Moon';
import Sun from './Sun';
import ArrowLeft from './ArrowLeft';
import ArrowRight from './ArrowRight';

const Icon = props => {
  switch (props.name) {
    case "data":
      return <Data {...props} />;
    case "location":
      return <Location {...props} />;
    case "menu":
      return <Menu {...props} />;
    case "other":
      return <Other {...props} />;
    case "people":
      return <People {...props} />;
    case "plus":
      return <Plus {...props} />;
    case "minus":
      return <Minus {...props} />;
    case "moon":
      return <Moon {...props} />;
    case "sun":
      return <Sun {...props} />;
    case "arrowleft":
      return <ArrowLeft {...props} />;
    case "arrowright":
      return <ArrowRight {...props} />;
    default:
      return;
  }
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/UI/Icons/index.js